import * as $message from 'coact/store/message'

export default function* invalidInvoice(payload, ctx) {
  try {
    const doc = ctx.getDoc()
    yield ctx.S.call(ctx.api.patch, {
      url: `/api/model/invoices/view/issuer/${doc._id}`,
      search: { action: 'invalid' },
    })
    ctx.history.push(`/edit/invoices/view/issuer/${doc._id}`)
    yield ctx.S.put(
      $message.act.send({ type: 'success', message: '發票已作廢' }),
    )
  } catch (error) {
    yield ctx.S.put(
      $message.act.send({ type: 'error', message: error.message }),
    )
  }
}
